import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { ShowMoreComponent } from "./show-more/show-more.component";

@NgModule({
  imports: [
    CommonModule,
    ButtonModule
  ],
  declarations: [ShowMoreComponent],
  exports: [ShowMoreComponent]
}) export class ShowMoreModule {}